export enum BACKGROUND {
	NONE = 'none',
	YELLOW = 'yellow',
	WHITE = 'white',
}
